/**
 * Map and tile-related constants.
 */

/**
 * Default tile size in pixels.
 * This is the size of each tile in the tilemap system.
 */
export const TILE_SIZE = 32;

/**
 * Isometric spacing constants for pixel-perfect alignment.
 * Using exact integer values to avoid floating-point precision issues.
 */
export const ISO_HORIZONTAL_SPACING = 16; // TILE_SIZE / 2 (exact integer)
export const ISO_VERTICAL_SPACING = 8; // TILE_SIZE / 4 (exact integer)

/**
 * Fine-tuning adjustment for isometric spacing.
 * Adjust this value to eliminate gaps or overlap between tiles.
 * Negative values tighten spacing, positive values loosen spacing.
 * Default: 0 (no adjustment, uses exact integer spacing)
 */
export const ISO_SPACING_ADJUSTMENT = -0.7;

/**
 * Default map width in tiles.
 */
export const MAP_TILE_WIDTH = 200;

/**
 * Default map height in tiles.
 */
export const MAP_TILE_HEIGHT = 200;
